import { Props_SnippetSpotlights } from './Spotlights.props'
import { CompileMarkdown, CompileHeadingToSpan } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetSpotlights = (props: Props_SnippetSpotlights) => {
    const { heading, text, barColor, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? 'snippet-spotlights__heading--visible' : 'snippet-spotlights__heading--hidden'
    const barColorClass: string = barColor.color?.value ? `snippet-spotlights__bar--${barColor.color.value}` : ''
    console.log(barColorClass)

    return (
        <section className="snippet-spotlights">
            <div className="snippet-spotlights__container">
                <div className="snippet-spotlights__header">
                    <span className={`snippet-spotlights__bar ${barColorClass}`} />
                    <h2 className={`snippet-spotlights__heading ${classHeadingVisibility}`}>{CompileHeadingToSpan(heading.content.value!)}</h2>
                    {text?.content?.value && <div className="snippet-spotlights__text">{CompileMarkdown(text.content.value)}</div>}
                </div>
                <div className="snippet-spotlights__cards">
                    {repeatable_entry.map(({ image, alt, name, role, content }, index: number) => (
                        <div key={index} className="snippet-spotlights__card">
                            {image?.value && (
                                <figure className="snippet-spotlights__card-image-container">
                                    <img
                                        className="snippet-spotlights__card-image"
                                        loading="lazy"
                                        height={262}
                                        width={243}
                                        src={image.value}
                                        alt={alt?.value ? alt.value : ''}
                                    />
                                </figure>
                            )}
                            <div className="snippet-spotlights__card-content-container">
                                {name?.value && <h3 className="snippet-spotlights__card-name">{name.value}</h3>}
                                {role?.value && <p className="snippet-spotlights__card-role">{role.value}</p>}
                                {content?.value && <div className="snippet-spotlights__card-content">{CompileMarkdown(content.value)}</div>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetSpotlights
